// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3PCvt","requiredAsterisk":"Info_requiredAsterisk__20mgL"};